import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export function KPIWidget({ label, value, delta, tone, icon, testid, onClick }) {
  const up = typeof delta === "number" && delta >= 0;
  const deltaColor = tone === "danger" ? "text-danger" : up ? "text-success" : "text-danger";
  return (
    <div data-testid={testid || "kpi-widget"} onClick={onClick} role={onClick ? "button" : undefined} tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === "Enter") onClick(); } : undefined}
      className={`bg-card border border-border rounded-2xl p-5 transition-all duration-300 hover:border-[hsl(var(--border-hover))] hover:-translate-y-0.5 ${onClick ? "cursor-pointer" : ""}`}>
      <div className="flex items-center justify-between">
        <p className="overline text-muted-foreground">{label}</p>
        {icon}
      </div>
      <div className="flex items-end gap-2 mt-2">
        <p className="font-display text-3xl font-bold tracking-tight">{value}</p>
        {typeof delta === "number" && (
          <span className={`flex items-center text-xs font-medium mb-1 ${deltaColor}`}>
            {up ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}{Math.abs(delta)}
          </span>
        )}
      </div>
    </div>
  );
}

export function StatsGrid({ items = [], cols = 4, testid = "stats-grid" }) {
  const c = { 2: "sm:grid-cols-2", 3: "sm:grid-cols-3", 4: "grid-cols-2 lg:grid-cols-4" }[cols] || "grid-cols-2 lg:grid-cols-4";
  return (
    <div data-testid={testid} className={`grid gap-4 ${c}`}>
      {items.map((it, i) => <KPIWidget key={i} {...it} />)}
    </div>
  );
}
